// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5342 ? "6e5c0b69" : chunkId) + "." + {"68":"eb4141adcfe5c48e","5342":"1a0bf5462bd3a314","5414":"bf88b8b820255d2b","8436":"496ff428f398e4d4"}[chunkId] + ".js";
};